// @flow

import { useMutation } from 'react-query';
import type { UseMutationOptions } from 'react-query';
import GrossRentsService from '../../../services/grossRentsService';
import useAbortController from '../../../hooks/useAbortController';

const grossRentsService = new GrossRentsService();

type BatchCompleteVariables = {
  affordableQualificationIds: string[],
};

const useBatchCompleteGrossRentCertificationsMutation = ({
  propertyId,
  organizationId,
  options,
}: {
  propertyId: string,
  organizationId: string,
  options?: UseMutationOptions<Object, mixed, BatchCompleteVariables, mixed>,
}) => {
  const abortControllerOptions = useAbortController();

  return useMutation(
    async ({ affordableQualificationIds }: BatchCompleteVariables) => {
      return grossRentsService.batchCompleteGrossRentCertifications(
        organizationId,
        propertyId,
        affordableQualificationIds,
        abortControllerOptions,
      );
    },
    options,
  );
};

export default useBatchCompleteGrossRentCertificationsMutation;
